export default "__VITE_ASSET__d1QevWiS__"